var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6074 2.24902C5.30004 2.24902 2.625 4.92406 2.625 8.23143C2.625 11.5388 5.30004 14.2138 8.6074 14.2138C9.78821 14.2138 10.881 13.8674 11.8076 13.2791L15.3821 16.8536C15.7948 17.2664 16.464 17.2664 16.8767 16.8536C17.2898 16.4405 17.2894 15.7706 16.8758 15.358L13.3581 11.8495C14.1252 10.8432 14.5898 9.59644 14.5898 8.23143C14.5898 4.92406 11.9148 2.24902 8.6074 2.24902ZM8.6074 3.65665C11.1409 3.65665 13.1822 5.69798 13.1822 8.23143C13.1822 10.7649 11.1409 12.8062 8.6074 12.8062C6.07396 12.8062 4.03262 10.7649 4.03262 8.23143C4.03262 5.69798 6.07396 3.65665 8.6074 3.65665Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e6d6c145611ba36c77571b409ff2d298.svg";
export { ForwardRef as ReactComponent };